/* @flow */

import React from 'react';

import SupplierDashboardComponent from 'app/suppliers/dashboard';
import WebsiteDashboardPageComponent from 'components/websiteStructure/pages/dashboard';

export default function SupplierDashboardPage() {
  return (
    <WebsiteDashboardPageComponent id="supplier.dashboard.title">
      <SupplierDashboardComponent />
    </WebsiteDashboardPageComponent>
  );
}
